// PageContainer — the ONE content-page frame (H1 fix, Playwright UX audit 02, 2026-07-03). Replaces the
// ~8 copy-pasted `mx-auto max-w-5xl px-8 py-8` wrappers AND the in-app `max-w-[1100px] p-6`, so content
// pages and mounted apps finally share ONE layout system.
//
// variant:
//  · "fluid" (default) — fills the canvas up to a sane cap (screen-2xl), for lists / overviews /
//    dashboards / card grids. Kills the 50–70% empty-canvas waste the audit flagged.
//  · "column" — a centered reading-width column (max-w-3xl), for prose / detail / forms.
// Prose blocks inside a fluid page should still cap their OWN measure (e.g. max-w-prose) so long lines
// stay readable — content-type awareness at the block level (operator ruling 2026-07-03).
import { type HTMLAttributes, type ReactNode } from "react";
import clsx from "clsx";

export interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: "fluid" | "column";
}

export function PageContainer({ children, variant = "fluid", className, ...rest }: PageContainerProps): React.ReactElement {
  return (
    <div
      className={clsx(
        "mx-auto w-full px-6 py-5",
        variant === "column" ? "max-w-3xl" : "max-w-screen-2xl",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
